jQuery(function(){
    AOS.init();
    initAnnoument();
    initItems();
    InitWishlist();
    initTabs();
    smoothscrolling();
    initCategoryMenu();
    SetUpdateNewUrl();
 
});

function initCategoryMenu(){

  //  $('.grandchild li').parent().parent().addClass("sss");
   $(".grandchild li.active").parent().parent().addClass("is-active");
 
}
function SetUpdateNewUrl(){
  
  $('.subcate_url').click(function(event) {
    event.preventDefault();
   // console.log(($(this).data('href')));
    let newPath = $(this).data('href');
   
    
    window.location.href = newPath;
});
}
// Grid and list collections
function initItems(){
  $(".facets-vertical-sort").insertBefore("#ProductGridContainer .collection");
  $('#list').click(function(event){event.preventDefault();$('#product-grid .home__collection__grid').addClass('list-group-item');});
  $('#grid').click(function(event){event.preventDefault();$('#product-grid .home__collection__grid').removeClass('list-group-item');$('#product-grid .home__collection__grid').addClass('grid-group-item');});
}

// open-close init
function initAnnoument() {
    $('.announcement').slick({
        centerMode: false,
        slidesToShow: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              slidesToShow: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              slidesToShow: 1
            }
          }
        ]
      });
}
function InitWishlist(){
  window.onload = function(){
    setInterval(function(){
        $(".product-form__buttons .swym-button-bar").appendTo(".wishlist");
        $("#shopify-block-96884bfb-9ca4-431c-952b-9acc52677fdb").appendTo(".price-reviews");
    }, 1000);
 };

}

function initTabs(){
  $('.tab-button').click(function() {
    $('.tab-button.active').removeClass('active');
    $(this).addClass('active');
    $('.content.active').removeClass('active');
    var tabNumber = $(this).attr('data-tab');
    var tabToOpen = ".content[data-tab='" + tabNumber + "']"; 
    $(tabToOpen).addClass('active');
  })

}
 function smoothscrolling(){
  $(document).on('click', '.table_contents p a[href^="#"]', function(e) {
    var id = $(this).attr('href');
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }

    e.preventDefault();
    var pos = $id.offset().top;
    $('body, html').animate({scrollTop: pos});
});

 }
 

  // let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // //console.log(items)
  // items.forEach(item => {
  //   item.addEventListener("mouseover", () => {
  //     item.setAttribute("open", true);
  //     item.querySelector("ul").addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //   item.addEventListener("mouseleave", () => {
  //     item.removeAttribute("open");
  //   });
  // });
  
  // });